import { locationChanged } from '../ducks/routing.duck';
import { setCurrentUser } from '../ducks/user.duck';

// Reference to the dispatchAnalyticsEvent function provided by context
let dispatchAnalyticsEvent = null;

// Function to set the dispatch reference from the Analytics Context
export const setAnalyticsDispatch = (dispatch) => {
  dispatchAnalyticsEvent = dispatch;
};

// RTK action type strings
const LOCATION_CHANGED = locationChanged.type;
const SET_CURRENT_USER = setCurrentUser.type;
// Upstream's auth slice fires these actions for fulfilled async thunks
const LOGIN_FULFILLED = 'auth/login/fulfilled';
const SIGNUP_FULFILLED = 'auth/signup/fulfilled';
const SIGNUP_WITH_IDP_FULFILLED = 'auth/signupWithIdp/fulfilled';

// Redux middleware that sends analytics events to PostHog via the context
export const analyticsMiddleware = store => next => action => {
  // Let the action go through first
  const result = next(action);

  // If we have a connection to analytics context and it's a relevant action
  if (dispatchAnalyticsEvent) {
    const { type, payload } = action;

    // Track page views when location changes
    if (type === LOCATION_CHANGED) {
      const previousPath = store.getState()?.routing?.currentCanonicalPath;
      const { canonicalPath } = payload;

      dispatchAnalyticsEvent({
        type: 'track_page_view',
        payload: {
          canonicalPath,
          previousPath,
        },
      });
    }

    // Track user after successful login/signup or when user data is fetched/updated
    if (
      type === LOGIN_FULFILLED ||
      type === SIGNUP_FULFILLED ||
      type === SIGNUP_WITH_IDP_FULFILLED ||
      type === SET_CURRENT_USER
    ) {
      const state = store.getState();
      const user = state.user.currentUser;

      if (user) {
        dispatchAnalyticsEvent({
          type: 'track_user',
          payload: {
            user,
          },
        });
      }
    }
  }

  return result;
};
